export const environment = {
  production: false,
  apiUrl: 'https://test-api.osmos-group.com/public/',
  googleMapsApiKey: 'AIzaSyAbdhAPSM--6ZTjaDVe3gsnb1ousLnDaQo',
  guardedRoute: 'api/',
  userLocalStored: '=VsVQet{gX5_aqud',
  levelLocalStored: 'selectedLevel_',
  clientId: '1_116tiya3ie8g80kkcosw4w4ggs840084wc8k0gko4w0s8ss0os',
  clientSecret: 'iuhtsa9puvk8kwkosksokokw0kwsogc4808okoogkskk4ssgk',
  grantType: 'password',
  pageSizeOptions: [5, 10, 20],
  pageSize: 10,
  userStatsTimeRange: '1_week',
  hubUrl: 'http://localhost:3000/.well-known/mercure',
  display_feature_export_async: true,
  enableLocalStorageViews: true,
  levelProjectDateLocked: [7],
  clientModeEnabled: true
};
